<div class="auto-ship-scroll" [class.loading-placeholder]="!hasBeenVisible">
  <ng-container *ngIf="hasBeenVisible && model">
    <div class="auto-ship-table" role="table" [attr.aria-label]="'autoShip.products.tableLabel' | cxTranslate">
      <div class="auto-ship-row auto-ship-header" role="row">
        <div role="columnheader">{{ 'autoShip.products.materialNumber' | cxTranslate }}</div>
        <div role="columnheader">{{ 'autoShip.products.materialDescription' | cxTranslate }}</div>
        <div role="columnheader">{{ 'autoShip.products.msrp' | cxTranslate }}</div>
        <div role="columnheader">{{ 'autoShip.products.netPrice' | cxTranslate }}</div>
        <div role="columnheader">{{ 'autoShip.products.orderQuantity' | cxTranslate }}</div>
      </div>

      <div
        *ngFor="let product of model.products; trackBy: trackByCode"
        class="auto-ship-row"
        role="row"
      >
        <div role="cell" [attr.data-label]="'autoShip.products.materialNumber' | cxTranslate">
          {{ product.code || '-' }}
        </div>
        <div role="cell" [attr.data-label]="'autoShip.products.materialDescription' | cxTranslate">
          {{ product.name || '-' }}
        </div>
        <div role="cell" [attr.data-label]="'autoShip.products.msrp' | cxTranslate">
          {{ product.price?.formattedValue || '-' }}
        </div>
        <div role="cell" [attr.data-label]="'autoShip.products.netPrice' | cxTranslate">
          <cx-spinner *ngIf="netPricesLoading; else netPrice" class="price-spinner"></cx-spinner>
          <ng-template #netPrice>
            <ng-container *ngIf="getNetPrice(product.code) as price; else noNetPrice">
              <ng-container *ngIf="price.value; else noNetPrice">
                {{ price.value | currency: price.currency }}
              </ng-container>
            </ng-container>
            <ng-template #noNetPrice>-</ng-template>
          </ng-template>
        </div>
        <div role="cell" [attr.data-label]="'autoShip.products.orderQuantity' | cxTranslate">
          <gen-item-counter
            [control]="getQuantityControl(product)"
            [min]="getAutoShipMinimum(product)"
            [step]="getAutoShipStep(product)"
            [max]="getAutoShipMaximum(product)"
            [allowZero]="true"
            [zeroToMin]="true"
            [inputReadonly]="true"
            [useWideMinusIcon]="true"
          ></gen-item-counter>
        </div>
      </div>
    </div>

    <p *ngIf="!model.products?.length" class="no-results">
      {{ 'productList.noResults' | cxTranslate }}
    </p>
  </ng-container>
</div>
